(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 220);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _convertLanguage;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var transformNodeText = function transformNodeText(text) {
  return text.toLowerCase().trim().replace(/[\s\-\.]/g, "_");
};

var removeTrailingSlash = function removeTrailingSlash(url) {
  return url[url.length - 1] === "/" ? url.slice(0, -1) : url;
};

var getPageNameFromLocation = function getPageNameFromLocation(href) {
  var hrefMatch = href.match(/(\.com|3000)(\/.*)/);

  if (!hrefMatch) return "/";

  return removeTrailingSlash(hrefMatch[2]);
};

var convertLanguage = (_convertLanguage = {
  "ca-en": "en_CA",
  ko: "ko_KR",
  fi: "fi_FI",
  zh: "zh_Hans-HK",
  au: "en_AU",
  gb: "en_GB",
  "la-es": "es_419",
  "ca-fr": "fr_CA",
  sv: "sv",
  it: "it-IT"
}, _defineProperty(_convertLanguage, "zh", "zh-Hans-HK"), _defineProperty(_convertLanguage, "fr", "fr"), _defineProperty(_convertLanguage, "pl", "pl-PL"), _defineProperty(_convertLanguage, "jp", "ja"), _defineProperty(_convertLanguage, "de", "de"), _defineProperty(_convertLanguage, "es", "es"), _defineProperty(_convertLanguage, "nl", "nl"), _defineProperty(_convertLanguage, "gsw", "gsw-CH"), _defineProperty(_convertLanguage, "za", "en-ZA"), _defineProperty(_convertLanguage, "ch", "fr-CH"), _convertLanguage);

var getVideoPayload = function getVideoPayload(currentPage, node) {
  var id = node.getAttribute("data-video-id");
  var from = currentPage;

  return { from: from, id: id };
};

var getPageCategory = function getPageCategory(pagename) {
  // remove preceding slash
  if (pagename[0] == "/") pagename = pagename.slice(1);

  var product = ["product", "features/smart-plan-viewer", "features/punch-list-app", "features/markups-and-measurements", "features/photos", "features/as-built-drawings", "features/cloud-software", "features/field-reports", "features/sheet-compare", "features/construction-document-control", "features/rfis", "features/reporting", "features/admin-console"];
  var customers = ["projects", "projects/Industrial", "projects/Commercial", "projects/Heavy%20Civil", "projects/Heavy civil", "projects/Heavy Civil", "projects/Healthcare", "projects/Education", "projects/Residential", "contractor-app", "subcontractor-app", "architecture-app", "owners"];
  var resources = ["integrations", "training", "jobs", "about", "press", "consulting", "user-groups", "events", "webinars", "https://help.plangrid.com/hc/en-us", "https://blog.plangrid.com", "resources"];

  if (product.indexOf(pagename) > -1) return "product_feature";
  if (customers.indexOf(pagename) > -1) return "customer_type";
  if (resources.indexOf(pagename) > -1) return "resource";

  return false;
};

var getToCategory = function getToCategory(href) {
  var category = getPageCategory(href);

  return category ? { category: category } : {};
};

var checkForInfo = function checkForInfo(node, to) {
  var nodeInfo = node.getAttribute("data-link-info");
  if (nodeInfo) return { link_info: nodeInfo };
  if (to[0] == "#") return { link_info: "scroll" };

  return {};
};

var checkForLocale = function checkForLocale(to, from) {
  var toLocale = convertLanguage[to.slice(1)];
  if (toLocale) return { locale: toLocale };

  if (from) {
    var fromLocale = convertLanguage[from.slice(1)];

    if (fromLocale) return { locale: fromLocale };
  }

  return {};
};

var getLinkClickPayload = function getLinkClickPayload(currentPage, node, _ref) {
  var location = _ref.location;

  var href = node.getAttribute("href") || node.getAttribute("data-link-category");

  var to = removeTrailingSlash(href);
  if (to.length === 0) to = "/";

  var toCategoryObj = getToCategory(to);
  var locationObj = location ? { location: location } : {};
  var localeObj = checkForLocale(to, currentPage);
  var linkInfoObj = checkForInfo(node, to);

  return Object.assign({ to: to, from: currentPage }, locationObj, linkInfoObj, toCategoryObj, localeObj);
};

var getSignupPayload = function getSignupPayload(currentPage, node) {
  var location = "body";
  var handlers = node.getAttribute("data-analytics-handler");

  if (handlers.indexOf("header-link-click") > -1) location = "header";

  var localeObj = checkForLocale(currentPage);

  return Object.assign({ from: currentPage, location: location }, localeObj);
};

var getPhonePayload = function getPhonePayload(currentPage, node) {
  var to = void 0;
  var href = removeTrailingSlash(node.getAttribute("href"));

  if (href.indexOf("contact") > 0) to = href;
  if (href.indexOf("tel") > -1) to = href.slice(4);

  var localeObj = checkForLocale(to, currentPage);

  return Object.assign({ to: to, from: currentPage, to_category: "phone", location: "header" }, localeObj);
};

var getViewContext = function getViewContext(pagename) {
  var lang = convertLanguage[pagename.slice(1)];
  var category = getPageCategory(pagename);

  var locale = lang ? lang : "en-US";

  if (category) {
    return {
      from: pagename,
      category: category,
      locale: locale
    };
  }

  return {
    from: pagename,
    locale: locale
  };
};

var getOffer = function getOffer(node) {
  var nodeData = node.getAttribute("data-engagement-type");

  if (nodeData) return nodeData;

  var href = node.getAttribute("href");

  if (href.indexOf("ebook") > -1) return "eBook";
  if (href.indexOf("webinar") > -1) return "Webinars";
  if (href.indexOf("itunes") > -1) return "ios_download";
  if (href.indexOf("play.google") > -1) return "android_download";
  if (href.indexOf("windows") > -1) return "windows_download";
  if (href.indexOf("contact") > -1) return "Contact";
  if (href.indexOf("tel:") > -1) return "Contact";
  if (href.indexOf("pdf") > -1) return "PDF";

  return "none";
};

var getOfferType = function getOfferType(offer) {
  var content = ["eBook", "Webinars", "Landing page", "Case study", "PDF"];
  var sales = ["Contact", "ROI", "Demo", "Learn_more"];
  var downloads = ["ios_download", "android_download", "windows_download"];

  if (content.includes(offer)) return "content_request";
  if (sales.includes(offer)) return "sales_request";
  if (downloads.includes(offer)) return "app_downloads";
};

var getEngageStartPayload = function getEngageStartPayload(currentPage, node) {
  var to = removeTrailingSlash(node.getAttribute("href"));

  var offer = getOffer(node);
  var type = getOfferType(offer);

  if (!type) console.error("Unknown offer type", node);

  return { to: to, offer: offer, type: type, from: currentPage };
};

var getEngageCompletePayload = function getEngageCompletePayload(currentPage, node) {
  var to = removeTrailingSlash(node.getAttribute("href"));
  var offer = getOffer(node);
  var type = getOfferType(offer);

  return { to: to, offer: offer, type: type, from: currentPage };
};

module.exports = {
  transformNodeText: transformNodeText,
  convertLanguage: convertLanguage,
  getVideoPayload: getVideoPayload,
  getViewContext: getViewContext,
  getLinkClickPayload: getLinkClickPayload,
  getPageNameFromLocation: getPageNameFromLocation,
  getPhonePayload: getPhonePayload,
  getSignupPayload: getSignupPayload,
  getEngageStartPayload: getEngageStartPayload,
  getEngageCompletePayload: getEngageCompletePayload,
  removeTrailingSlash: removeTrailingSlash
};

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = undefined;

var _analyticsHandlers = __webpack_require__(2);

var _analyticsHandlers2 = _interopRequireDefault(_analyticsHandlers);

var _analytics = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Throttling function for scrolling events
 */
function throttle(delay, callback) {
  var previousCall = new Date().getTime();
  return function () {
    var time = new Date().getTime();

    if (time - previousCall >= delay) {
      previousCall = time;
      callback.apply(null, arguments);
    }
  };
}

var checkForProdOrTest = function checkForProdOrTest(url) {
  return url.match(/^https?\:\/\/www\.plangrid\.com/) || url.match(/plangrid(\.com)?\/public\//);
};

var trackEvent = exports.trackEvent = function trackEvent(event, payload) {
  if (checkForProdOrTest(window.location.href)) {
    payload ? analytics.track(event, payload) : analytics.track(event);
  } else {
    console.log("EVENT: ", event, payload);
  }
};

var getDataHandlerAttr = function getDataHandlerAttr(node) {
  return node.getAttribute("data-analytics-handler");
};

var getEventData = function getEventData(handler, currentPage, node) {
  var eventData = _analyticsHandlers2.default[handler];

  if (!eventData) {
    console.warn("No analytics handler for: " + handler + ", page: " + currentPage + ", node: " + node);
    return false;
  }

  return _analyticsHandlers2.default[handler](currentPage, node);
};

var attachClickEvent = function attachClickEvent(node, eventName, payload) {
  node.addEventListener("click", function (e) {
    trackEvent(eventName, payload);
  });
};

var attachHoverEvent = function attachHoverEvent(node, eventName, payload) {
  node.addEventListener("mouseenter", function (e) {
    e.stopPropagation();
    trackEvent(eventName, payload);
  });
};

var attachHoverNoClickEvent = function attachHoverNoClickEvent(node, eventName, payload) {
  node.addEventListener("mouseenter", function (e) {
    var clicked = false;
    var called = false;

    node.addEventListener("mousedown", function () {
      clicked = true;
    });

    node.addEventListener("mouseout", function (e) {
      if (!clicked && !called) {
        trackEvent(eventName, payload);
        called = true;
      }

      node.removeEventListener("mousedown");
      node.removeEventListener("mouseout");
    });
  });
};

var checkEventOptions = function checkEventOptions(pageName, options) {
  if (!(options && options.ignoreView)) {
    trackEvent("public_web.page.view", (0, _analytics.getViewContext)(pageName));
  }
  if (options && options.trackScrolling) {
    addScrollEvent(pageName);
  }
};

var addCampaignTracking = function addCampaignTracking() {
  var campaignUtils = {};

  /*
   * Turn query param string into a hash.
   */
  campaignUtils.deparam = function deparam(str) {
    var pairs, hash;
    // remove the '?'
    if (!str || !str.length) {
      return;
    }

    if (str[0] === "?") {
      str = str.slice(1);
    }
    str = decodeURIComponent(str);

    // this gives back something of the form: [[key1, val1], [key2, val2]]
    pairs = str.split("&").map(function (item) {
      return item.split("=");
    });

    hash = {};
    pairs.forEach(function (pair) {
      hash[pair[0]] = pair[1];
    });

    return hash;
  };

  campaignUtils.extractCampaignAttributionData = function extractCampaignAttributionData(queryParams) {
    var campaignFields, campaignData;
    campaignFields = ["utm_source", "utm_medium", "utm_term", "utm_content", "utm_campaign"];
    campaignData = {};

    queryParams && campaignFields.forEach(function (field) {
      if (queryParams[field]) {
        campaignData[field] = queryParams[field];
      }
    });

    return campaignData;
  };

  var query, campaignData;
  query = campaignUtils.deparam(window.location.search);
  campaignData = campaignUtils.extractCampaignAttributionData(query);
  if (campaignData && campaignData.utm_campaign) {
    analytics.track("campaign", campaignData);
  }
};

var addScrollEvent = function addScrollEvent(pageName) {
  var sections = [].slice.call(document.querySelectorAll("section"));

  window.onscroll = throttle(300, function () {
    sections.forEach(function (thisSection, index, sectionArray) {
      var eventProperties = {};

      if (window.pageYOffset >= thisSection.offsetTop) {
        eventProperties.page_element = thisSection.getAttribute("data-scroll-element");
        trackEvent("splash." + pageName + ".scroll", eventProperties);
        sections.splice(index, 1);
      }
    });
  });
};

var getAnalyticsHandlers = function getAnalyticsHandlers(node) {
  return getDataHandlerAttr(node).split(",").map(function (el) {
    return el.trim();
  });
};

var attachAnalyticsToDOM = function attachAnalyticsToDOM(currentPage, options) {
  document.querySelectorAll("[data-analytics-handler]").forEach(function (node) {
    var handlers = getAnalyticsHandlers(node);

    handlers.forEach(function (handler) {
      var eventData = getEventData(handler, currentPage, node);

      if (!eventData) {
        return;
      }

      var eventType = eventData.eventType,
          eventName = eventData.eventName,
          payload = eventData.payload;


      if (eventType === "click") {
        attachClickEvent(node, eventName, payload);
      }

      if (eventType === "hover") {
        attachHoverEvent(node, eventName, payload);
      }

      if (eventType === "hover-no-click") {
        attachHoverNoClickEvent(node, eventName, payload);
      }
    });
  });
};

var plangridTrackEvents = function plangridTrackEvents(pageName, options) {
  checkEventOptions(pageName, options);
  addCampaignTracking();
  attachAnalyticsToDOM(pageName);
};

exports.default = plangridTrackEvents;

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classify = __webpack_require__(153);

var _classify2 = _interopRequireDefault(_classify);

var _amplitudeInitVanilla = __webpack_require__(1);

var _amplitudeInitVanilla2 = _interopRequireDefault(_amplitudeInitVanilla);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addSecurityScrollHandlers = function addSecurityScrollHandlers() {
  var navLinks = document.querySelectorAll(".navigation a");
  var navigation = document.querySelector(".security-page .navigation");

  navLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      navigation.classList.remove("open");
      var section = void 0;

      var className = (0, _classify2.default)(link.innerHTML.trim());

      if (className == "international-service") {
        section = document.querySelector("#available-worldwide");
      } else {
        section = document.querySelector("#" + className);
      }

      section.scrollIntoView();

      window.scrollBy(0, -95);
    });
  });
};

var addScrollHandler = function addScrollHandler() {
  var container = document.querySelector(".navigation ul");
  var footer = document.querySelector("#footer-navigation");
  var page = document.querySelector(".content");

  var margin = 120;

  window.addEventListener("scroll", function () {
    var containerHeight = Math.min(container.offsetHeight, page.offsetHeight);
    var footerHeight = footer.offsetHeight;
    var footerTop = document.body.offsetHeight - footerHeight;

    if (window.matchMedia("(min-width: 62em)").matches) {
      if (containerHeight + pageYOffset + margin > footerTop) {
        container.style.position = "fixed";
        container.style.top = "100px";
        container.style.maxHeight = (pageYOffset + margin - footerTop) * -1 + "px";
      } else if (pageYOffset > 280) {
        container.style.position = "fixed";
        container.style.top = "100px";
        container.style.maxHeight = "500px";
      } else {
        container.style.position = "absolute";
        container.style.top = "0";
        container.style.maxHeight = Math.min(500, page.offsetHeight) + "px";
        document.body.overflowY = "auto";
      }
    }
  });
};

var addNavigationHandler = function addNavigationHandler() {
  var navigation = document.querySelector(".security-page .navigation");
  var button = navigation.querySelector("button");

  button.addEventListener("click", function (e) {
    navigation.classList.toggle("open");
  }, false);

  document.body.addEventListener("click", function (e) {
    if (!navigation.contains(e.target)) {
      navigation.classList.remove("open");
    }
  }, false);
};

var submitWebinarForm = function submitWebinarForm() {
  var joinForm = MktoForms2.getForm(1241);
  var form = document.forms["soc2-report-request"];
  var wrapper = document.querySelector(".report-request");

  joinForm.onSuccess(function (values, followUpUrl) {
    wrapper.classList.add("confirmation");
    return false;
  });

  joinForm.setValues({
    Email: form.email.value
  });

  joinForm.submit();
};

var addMarketoHandlers = function addMarketoHandlers() {
  var form = document.forms["soc2-report-request"];

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var email = form.email.value;
    var emailValid = /@.*?\./.test(email);

    if (emailValid) {
      submitWebinarForm();
    } else {
      form.classList.add("email-error");
    }
  });
};

var init = function init() {
  addSecurityScrollHandlers();
  addScrollHandler();
  (0, _amplitudeInitVanilla2.default)("/security");
  addNavigationHandler();
  addMarketoHandlers();
  MktoForms2.loadForm("//app-ab10.marketo.com", "572-JSV-775", 1241);
};

document.addEventListener("DOMContentLoaded", init);

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
  if (!str) return "";
  return str.trim().toLowerCase().replace(/[^\s\w-]+/g, "").replace(/[^\w]+/g, "-");
};

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _analytics = __webpack_require__(0);

module.exports = {
  "header-link-click": function headerLinkClick(currentPage, node) {
    return {
      eventType: "click",
      eventName: "public_web.page.link.click",
      payload: (0, _analytics.getLinkClickPayload)(currentPage, node, { location: "header" })
    };
  },
  "footer-link-click": function footerLinkClick(currentPage, node) {
    return {
      eventType: "click",
      eventName: "public_web.page.link.click",
      payload: (0, _analytics.getLinkClickPayload)(currentPage, node, { location: "footer" })
    };
  },
  "header-phone-click": function headerPhoneClick(currentPage, node) {
    return {
      eventType: "click",
      eventName: "public_web.page.link.click",
      payload: (0, _analytics.getPhonePayload)(currentPage, node)
    };
  },
  "signup-link-click": function signupLinkClick(currentPage, node) {
    return {
      eventType: "click",
      eventName: "public_web.page.engage.sign_up",
      payload: (0, _analytics.getSignupPayload)(currentPage, node)
    };
  },
  "engage-link-click": function engageLinkClick(currentPage, node) {
    return {
      eventType: "click",
      eventName: "public_web.page.engage.start",
      payload: (0, _analytics.getEngageStartPayload)(currentPage, node)
    };
  },
  "body-link-click": function bodyLinkClick(currentPage, node) {
    return {
      eventType: "click",
      eventName: "public_web.page.link.click",
      payload: (0, _analytics.getLinkClickPayload)(currentPage, node, { location: "body" })
    };
  },
  "video-click": function videoClick(currentPage, node) {
    return {
      eventType: "click",
      eventName: "public_web.page.video.click",
      payload: (0, _analytics.getVideoPayload)(currentPage, node)
    };
  }
};

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(114);

__webpack_require__(143);

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// /assets/js/security.73d6f7aec279b64e6cc0.js